import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background pt-32 pb-16">
      <Helmet>
        <title>Privacy Policy | Synthetic Trading Hub</title>
        <meta name="description" content="Learn how we collect, use, and protect your information on Synthetic Trading Hub." />
        <meta name="keywords" content="synthetic trading, synthetic indices trading, deriv trading guide, crash boom trading, trading for beginners, online trading platform" />
        <meta property="og:title" content="Privacy Policy | Synthetic Trading Hub" />
        <meta property="og:description" content="Learn how we collect, use, and protect your information on Synthetic Trading Hub." />
        <meta property="og:url" content="https://synthetictradinghub.com/privacy" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | Synthetic Trading Hub" />
        <meta name="twitter:description" content="Learn how we collect, use, and protect your information on Synthetic Trading Hub." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1569025743873-ea3a9ade89f9" />
        <link rel="canonical" href="https://synthetictradinghub.com/privacy" />
      </Helmet>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString('en-GB')}</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">1. Who we are</h2>
            <p>
              This website is an independent affiliate landing page that promotes the Deriv trading platform.
              We are not the operator of the Deriv platform. Account registration, login, and data handling
              for trading are governed by Deriv&apos;s own privacy policy at{' '}
              <a href="https://deriv.com" target="_blank" rel="noopener noreferrer" className="text-[#ff444f] hover:underline">deriv.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">2. Information we collect on this site</h2>
            <p>
              When you visit this site we may collect technical information such as your IP address, browser type,
              and pages visited. We may use cookies and similar technologies for analytics and to improve the site.
              If you click through to the official Deriv website, any data you provide there is subject to Deriv&apos;s privacy policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">3. How we use information</h2>
            <p>
              We use collected information to operate and improve this website, analyse traffic, and for
              affiliate marketing purposes in accordance with applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">4. Third parties</h2>
            <p>
              We may use third-party services (e.g. analytics such as PostHog). Those services have their own privacy policies.
              When you leave this site for Deriv or other links, their policies apply.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">5. Cookies and tracking</h2>
            <p>
              We use cookies and similar technologies to understand site usage, improve performance, and measure
              affiliate campaign effectiveness. By continuing to use this site, you consent to this processing where
              permitted by law. You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">6. Your rights</h2>
            <p>
              Depending on your location, you may have rights to access, correct, or delete personal data we hold.
              Contact us using the details on this site if you have questions. For matters related to your Deriv
              account, please contact Deriv directly.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">7. Changes</h2>
            <p>
              We may update this policy from time to time. The &quot;Last updated&quot; date at the top will be revised accordingly.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link to="/" className="text-[#ff444f] font-semibold hover:underline">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
